import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import wx from 'kkt-weixin'
import dm from 'kkt-domain'

Vue.use(Router)

// 创建路由对象
const router = new Router({
  base: '/',
  mode: 'history',
  linkActiveClass: 'active',
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 百度pv统计
  if (to.path) {
    _hmt.push(['_trackPageview', to.fullPath])
  }

  next()
})
// 路由导航后事件
router.afterEach(route => {
  // 延迟 100 毫秒执行
  setTimeout(() => {
    // 注册微信jssdk权限
    wx.register({
      url: encodeURIComponent(location.href),
      api: dm.get() + '/basedata/wxsetting/getjssdk'
    })
  }, 100)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js